import Swal from 'sweetalert2';
import { AddCreditCardRequest } from 'app/models/ss-api/requests/add.credit.card.request';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { CreditCardResponse, CreditCardTypes } from 'app/models/ss-api/responses/credit.card.response';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ssApiService } from 'app/services/ss-api.service';
import { CreditCardResponseArray } from 'app/models/ss-api/responses/credit.card.response';
import { HttpError } from 'app/models/errors/HttpError';
import { CreditCard } from 'angular-cc-library';
import { MemberBasicInfoResponse } from 'app/models/ss-api/responses/member.basic.info.response';
import * as moment from 'moment';
import { GlobalServices } from 'app/services/global.service';
import { CreditCardHelper } from 'app/helpers/creditcard';


function CustomCreditCardValidator(c: UntypedFormControl) {

  let cardType = CreditCardHelper.GetCardTypes(c.value);

  if (cardType == CreditCardTypes.Unknown || cardType == null) {
    return {
      CustomCreditCardValidator: {
        valid: false
      }
    }
  } else {
    return null;
  }

}


@Component({
  selector: 'credit-card-add',
  templateUrl: './credit-card-add.component.html',
  styleUrls: ['./credit-card-add.component.scss']
})
export class CreditCardAddComponent implements OnInit {


  @Input('showCancel') showCancel: boolean = false;
  @Input('ReturnDefaultCard') ReturnDefaultCard: boolean = true;

  @Output('cardAdded') cardAdded: EventEmitter<any> = new EventEmitter();
  @Output('cancelAdd') cancelAdd: EventEmitter<any> = new EventEmitter();

  @Output('close') close: EventEmitter<any> = new EventEmitter();


  // dialog confirm add creditcard
  Add_Confirm_Title: string = 'Add New Credit Card?';
  Add_Confirm_Text: string = 'You are about to add a new Credit Card.';

  // dialog added info
  Add_Added_Title: string = 'Saved!';
  Add_Added_Text: string = 'New Credit Card Saved.';
  Add_Added_Timeout: number = 1500;

  // dialog confirm delete creditcard
  Delete_Confirm_Title: string = 'Delete Credit Card?';
  Delete_Confirm_Text: string = 'You are about to delete a Credit Card.';

  // dialog deleted info
  Delete_Deleted_Title: string = 'Deleted!';
  Delete_Deleted_Text: string = 'Credit Card Deleted.';
  Delete_Deleted_Timeout: number = 1500;

  // dialog confirm set default creditcard
  SetDefault_Confirm_Title: string = 'Change default Credit Card?';
  SetDefault_Confirm_Text: string = 'You are about to change your default Credit Card.';

  // dialog default saved info
  SetDefault_Saved_Title: string = 'Saved!';
  SetDefault_Saved_Text: string = 'New default Credit Card saved.';
  SetDefault_Saved_Timeout: number = 1500;

  // YEAR OPTIOINS FOR FORM
  Year: number = new Date().getFullYear();
  YearRange: any[] = [];

  // response stuff
  Cards: CreditCardResponseArray;
  DefaultCard: CreditCardResponse;

  submitted: boolean = false;
  ccardForm: UntypedFormGroup;
  ccForm: UntypedFormGroup;
  formSetAsDefaultVisible: boolean = true;

  public IsBusy: boolean = false;

  public MemberBasicInfo: MemberBasicInfoResponse = new MemberBasicInfoResponse();

  constructor(
    private api: ssApiService,
    private _fb: UntypedFormBuilder,
    // private sweetAlertService: SweetAlertService,
    public gb: GlobalServices) {
  }


  ngOnInit() {
    console.log(new Date().getFullYear());

    this.RefreshCards();

    this.gb.CheckMemberInfo();

    this.ccForm = this._fb.group({
      creditCard: ['', [CustomCreditCardValidator]],
      expMonth: [this.ThisMonth(), [Validators.required]],
      expYear: [new Date().getFullYear(), [Validators.required]],
      cvc: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(4)]],
      firstName: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
      lastName: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
      zipCode: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(10)]],
    }),

      this.ccardForm = this._fb.group({
        creditCard: this.ccForm,
        state: ['', [Validators.minLength(2)]],
        address1: ['', [<any>Validators.minLength(3)]],
        zipCode: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(10)]],
        country: new UntypedFormControl('', [Validators.required]),
        city: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
        setAsDefault: [true]
      });

    // SET UP YEAR DROPDOWN
    for (let i: number = 0; i < 15; i++) {
      this.YearRange.push(this.Year + i);
    }



  }

  isValidExpiration() {
    let ccExpMonth = this.ccForm.get('expMonth').value;
    let ccExpYear = this.ccForm.get('expYear').value;

    if (moment(ccExpMonth + '/' + ccExpYear, 'MM/YYYY').isSameOrAfter(moment(moment().format('MM/YYYY'), 'MM/YYYY'))) {
      return true;
    } else {
      return false;
    }
  }

  ThisMonth() {
    const month = new Date().getMonth() + 1;

    if (month < 10) {
      return '0' + month;
    } else {
      return month;
    }
  }

  preFillBillingInfo(data: MemberBasicInfoResponse) {

    this.ccardForm.controls.firstName.setValue(data.Firstname);
    this.ccardForm.controls.lastName.setValue(data.Lastname);
    this.ccardForm.controls.address1.setValue(data.Address1);
    this.ccardForm.controls.city.setValue(data.City);
    this.ccardForm.controls.country.setValue(data.Country);
    this.ccardForm.controls.zipCode.setValue(data.ZipCode);
    this.ccardForm.controls.state.setValue(data.State);
    this.ccardForm.controls.setAsDefault.setValue(true);

  }

  refreshPreFillData() {

    // if we have the data skip fetch
    if (this.MemberBasicInfo.Firstname != undefined && this.MemberBasicInfo.Firstname != '') {
      this.preFillBillingInfo(this.MemberBasicInfo);
      return;
    }


    // fetch the data on the server
    this.IsBusy = true;

    let request = this.api.MemberBasicInfo()
      .subscribe(response => {
        request.unsubscribe();

        this.IsBusy = false;

        if (!response.Result)
          return; // error

        this.MemberBasicInfo = response.Data;
        this.preFillBillingInfo(response.Data);

      },


        (error: HttpError) => {
          request.unsubscribe();
          this.IsBusy = false;
        }
      );


  }


  ProcessDefaultCardArray(newDefaultCardID: number) {
    /*
    //reset default card and put in global array
    this.DefaultCard.IsDefault = false;
    this.Cards.push(this.DefaultCard);

    //find default card
    let index = this.Cards.findIndex(x => x.ID == newDefaultCardID);

    //set default card
    this.DefaultCard = this.Cards[index];
    this.DefaultCard.IsDefault = true;

    //remove default card from list
    this.Cards.splice(index, 1);
    */
  }




  SetCardAsDefault(id: number): Promise<any> {

    this.IsBusy = true;

    return this.api.CreditCardSetDefault(id)
      .toPromise()
      .then(response => {

        this.IsBusy = false;

        if (!response.Result)
          return; // error

        // ok
        this.ProcessDefaultCardArray(id);

      })
      .catch((error: HttpError) => {
        this.IsBusy = false;
      });

  }


  getExpDateMonth(month: string): string {

    try {

      // let month = expDate.split('/')[0].trim();
      if (month.length == 1)
        return '0' + month;
      else
        return month;

    } catch (e) {
      return '0';
    }
  }

  getExpDateYear(year: string): string {

    try {

      // let year = expDate.split('/')[1].trim();
      if (year.length == 2)
        return '20' + year;
      else
        return year;

    } catch (e) {
      return '0';
    }
  }

  getDateCreated(createdDate: Date): any {
    if (createdDate == undefined)
      return '';

    let returnDate = createdDate.getDay() + '/' + createdDate.getMonth() + '/' + createdDate.getFullYear();
    return returnDate;
  }

  SubmitNewCreditCard(ccardForm: UntypedFormGroup) {

    console.log(ccardForm);

    this.submitted = true;

    // check form is valid
    if (!this.ccForm.valid)
      return;

    // check card is valid
    let ccard = this.ccForm.controls.creditCard;
    if (!ccard.valid)
      return;

    console.log('ccard + ', ccard);

    // check expiration is valid
    // let expDate = ccardForm.controls.expDate;
    // if (!expDate.valid)
    // 	return;

    // extract expiration month and year
    let expMonth = this.getExpDateMonth(this.ccForm.controls.expMonth.value);
    let expYear = this.getExpDateYear(this.ccForm.controls.expYear.value);
    // let expMonth = ccardForm.controls.expMonth.value;
    // let expYear = ccardForm.controls.expYear.value;

    // check cvc
    // let cvc = ccardForm.controls.cvc;
    // if (!cvc.valid)
    // return;

    // get credit card type
    let card = CreditCard.cardFromNumber(this.ccForm.controls.creditCard.value);
    let ctype = card.type;

    // get other data
    let address1 = ccardForm.controls.address1.value;
    let city = ccardForm.controls.city.value;
    let country = ccardForm.controls.country.value;
    let zipCode = this.ccForm.controls.zipCode.value;
    let state = ccardForm.controls.state.value;
    let setAsDefault = ccardForm.controls.setAsDefault.value;
    let firstName = this.ccForm.controls.firstName.value;
    let lastName = this.ccForm.controls.lastName.value;

    // put date in request
    let newCard = new AddCreditCardRequest();

    // newCard.Address01 = address1;
    newCard.CardType = CreditCardResponse.GetCreditCardTypeFromString(ctype);
    // newCard.City = city;
    // newCard.Country = country;
    newCard.CreditCardNumber = ccard.value;
    newCard.CVV = Number.parseInt(this.ccForm.controls.cvc.value);
    newCard.ExpMonth = Number.parseInt(expMonth);
    newCard.ExpYear = Number.parseInt(expYear);
    // newCard.State = state;
    newCard.SetAsDefault = (setAsDefault == null) ? false : setAsDefault;
    newCard.FirstName = firstName;
    newCard.LastName = lastName;
    newCard.ZipCode = zipCode;

    console.log(newCard);

    // confirm
    Swal.fire({
      title: this.Add_Confirm_Title,
      text: this.Add_Confirm_Text,
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes, add!',
      cancelButtonText: 'No, cancel',
      allowOutsideClick: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        // addcard
        return this.AddCreditCard(newCard);
      }
    })
      .then(
        (response) => {

          // reset form
          // this.ccardForm.controls.cvc.setValue('');
          // this.ccardForm.controls.creditCard.setValue('');
          // this.ccardForm.controls.expDate.setValue("");

          if (response.isDismissed) {
            // show cancelled
            Swal.fire({
              title: 'Cancelled',
              text: 'No changes are saved.',
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000
            })
              .then(() => { }, () => { }); // keep this line to prevent promise error;
          } else {
            // show confirmation
            Swal.fire(
              {
                title: this.Add_Added_Title,
                text: this.Add_Added_Text,
                icon: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer: this.Add_Added_Timeout
              })
              .then(() => { }, () => { }); // keep this line to prevent promise error;
          }

        },
        (dismiss) => {
          if (dismiss === 'cancel') {

            if (!confirm)
              return;

            // show cancelled
            Swal.fire({
              title: 'Cancelled',
              text: 'No changes are saved.',
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000
            })
              .then(() => { }, () => { }); // keep this line to prevent promise error;
          }
        });
  }




  AddCreditCard(newCard: AddCreditCardRequest): Promise<any> {

    this.IsBusy = true;

    return this.api.CreditCardAdd(newCard).toPromise()
      .then(
        response => {
          this.IsBusy = false;

          if (response.Result) {
            // switch tabs
            this.RefreshCards(true, newCard);
            return true;
          }

          Swal.fire({
            title: 'Failed',
            text: response.Message,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000
          })
            .then(() => { }, () => { }); // keep this line to prevent promise error;
          return false;
        },
      )
      .catch((error: HttpError) => {
        this.IsBusy = false;
      }
      );


  }

  RefreshCards(closeMe: boolean = false, newCard?: AddCreditCardRequest): void {

    this.IsBusy = true;

    let request = this.api.CreditCardGetAll()
      .subscribe(response => {
        request.unsubscribe();

        this.IsBusy = false;

        if (!response.Result)
          return; // error

        if (response.Data.length == 0)
          return;

        this.Cards = response.Data;

        // find default card
        let index = this.Cards.findIndex(x => x.IsDefault == true);

        // set default card
        this.DefaultCard = this.Cards[index];

        // remove default card from list
        if (!this.ReturnDefaultCard)
          this.Cards.splice(index, 1);

        if (closeMe) {
          const newCardId = this.Cards.find(card => card.FirstName === newCard.FirstName && card.LastName === newCard.LastName && card.LastFour === newCard.CreditCardNumber.slice(-4))?.ID;
          this.cardAdded.emit({ cards: this.Cards, newCardId });
        }

      },


        (error: HttpError) => {
          request.unsubscribe();
          this.IsBusy = false;
        }
      );


  }


  cancel() {
    this.cancelAdd.emit(false);
  }

  Close() {
    this.close.emit(false);
  }

  isFormValid() {

  }
}
